import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { H6, Image, P } from "../../../AbstractElements";
import { User, Users } from "react-feather";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";

interface UsersTableBodyProps {
  users?: any
  clinicians?: any
  patients?: any
  reports?: any
  templates?: any
}


const UserStatus: React.FC<UsersTableBodyProps> = ({ users = [], clinicians = 0, patients = 0, reports = 0, templates = 0 }) => {
  const user = useAppSelector(state => state.user)
  return (
    user.role === "admin" ?
      <Col xxl="8" xl="8" className="">
        <Card>
          <CommonCardHeader headClass="card-no-border pb-0" title={"Users Overview"} />
          <CardBody className="project-status-col">
            <Row>
              <Col xxl="3">
                <div className={`btn-light1-secondary b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-secondary`}>
                      <Users />
                    </div>
                    <H6>{"Clinicians"}</H6>
                    <P>{clinicians}</P>
                  </div>
                </div>
              </Col>
              <Col xxl="3">
                <div className={`btn-light1-danger b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-danger`}>
                      <User />
                    </div>
                    <H6>{"Patients"}</H6>
                    <P>{patients}</P>
                  </div>
                </div>
              </Col>
              <Col xxl="3">
                <div className={`btn-light1-primary b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-primary`}>
                      {/* <Image src={dynamicImage(`dashboard-2/svg-icon/processing.png`)} alt="icons" /> */}
                      <User />
                    </div>
                    <H6>{"Reports"}</H6>
                    <P>{reports}</P>
                  </div>
                </div>
              </Col>
              <Col xxl="3">
                <div className={`btn-light1-warning b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-warning`}>
                      {/* <Image src={dynamicImage(`dashboard-2/svg-icon/processing.png`)} alt="icons" /> */}
                      <User />
                    </div>
                    <H6>{"Templates"}</H6>
                    <P>{templates}</P>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col> :
      <Col xxl="4" xl="4" className="">
        <Card>
          <CommonCardHeader headClass="card-no-border pb-0" title={"Users Overview"} />
          <CardBody className="project-status-col">
            <Row>
              <Col xxl="6">
                <div className={`btn-light1-primary b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-primary`}>
                      {/* <Image src={dynamicImage(`dashboard-2/svg-icon/processing.png`)} alt="icons" /> */}
                      <User />
                    </div>
                    <H6>{"User accounts"}</H6>
                    <P>{`${users.filter((user: any) => user.role === 'USER').length} users`}</P>
                  </div>
                </div>
              </Col>
              <Col xxl="6">
                <div className={`btn-light1-warning b-r-10`}>
                  <div className={`upcoming-box`}>
                    <div className={`upcoming-icon bg-warning`}>
                      {/* <Image src={dynamicImage(`dashboard-2/svg-icon/processing.png`)} alt="icons" /> */}
                      <User />
                    </div>
                    <H6>{"Inactive accounts"}</H6>
                    <P>{`${users.filter((user: any) => user.status === 'InActive').length} users`}</P>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
  );
};

export default UserStatus;
